export default {
  description:
    'Încarcă documentele de care avem nevoie pentru a-ți verifica afacerea. Documentele obligatorii sunt marcate; le poți adăuga pe cele opționale acum sau mai târziu.',
  missing_one: 'Mai lipsește un document obligatoriu. Poți continua: acest pas rămâne deschis până când este încărcat.',
  missing_few:
    '{{count}} documente obligatorii mai lipsesc încă. Poți continua: acest pas rămâne deschis până când sunt încărcate.',
  missing_other:
    '{{count}} de documente obligatorii mai lipsesc încă. Poți continua: acest pas rămâne deschis până când sunt încărcate.',
  buttons: {
    back: 'Înapoi',
    next: 'Următorul',
    finish_later: 'Termină mai târziu',
  },
};
